// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Gmu8","container":"styles_container__10z8K","title":"styles_title__37RZv","wrapper":"styles_wrapper__EQ2IS","answer":"styles_answer__3LrHh"};